import { render, staticRenderFns } from "./JuridicoPrincipalAuditoria.vue?vue&type=template&id=05f768c7&"
import script from "./JuridicoPrincipalAuditoria.vue?vue&type=script&lang=js&"
export * from "./JuridicoPrincipalAuditoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports